import { ActivatedRouteSnapshot, Params, RouterStateSnapshot } from '@angular/router';
import * as fromRouter from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

export const routerFeatureKey = 'routerReducer';

export interface RouterStateUrl {
    url: string;
    params: Params;
}

export interface State {
    routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = { routerReducer: fromRouter.routerReducer };

export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
    public serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        const { url } = routerState;

        let state: ActivatedRouteSnapshot | null = routerState.root;
        let params: Params = {};
        // Merge params from all route levels so deep links work independent of inheritance strategy.
        while (state) {
            params = { ...params, ...state.params };
            state = state.firstChild;
        }

        return { url, params };
    }
}
